import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { asc, desc } from "../../assets/icons";
import { useQueries } from "../../helpers/query_searchParams/QuerySearchParams";

interface IProps {
  option: any[];
  defaultSort?: any;
}

const NewSorting: React.FC<IProps> = ({ option, defaultSort }) => {
  const query = useQueries(useLocation);
  const { search, pathname, hash } = useLocation();
  const history = useHistory();

  const handleAsc = () => {
    const prevAsc: any = query.get("isAsc");
    if (prevAsc === "asc") {
      let new_search;
      prevAsc !== null
        ? (new_search = search.replace(`isAsc=${prevAsc}`, "isAsc=desc"))
        : (new_search = `${search}&&isAsc=desc`);
      history.push({ pathname, search: new_search, hash });
    } else {
      let new_search;
      prevAsc !== null
        ? (new_search = search.replace(`isAsc=${prevAsc}`, "isAsc=asc"))
        : (new_search = `${search}&&isAsc=asc`);
      history.push({ pathname, search: new_search, hash });
    }
  };

  const handleSort = (event: any) => {
    const prevSort: any = query.get("sort");
    let target = event.target.value;
    let new_search;
    prevSort !== null
      ? (new_search = search.replace(`sort=${prevSort}`, `sort=${target}`))
      : (new_search = `${search}&&sort=${target}`);
    history.push({ pathname, search: new_search, hash });
  };

  return (
    <div className="flex justify-end items-center">
      {query.get("isAsc") === "asc" ? (
        <img
          className="cursor-pointer md:w-7 w-5"
          onClick={handleAsc}
          src={asc}
          alt="icon"
        />
      ) : (
        <img
          className="cursor-pointer md:w-7 w-5"
          onClick={handleAsc}
          src={desc}
          alt="icon"
        />
      )}

      <div className="border-2 border-softGray md:h-10 h-8 md:w-28 w-20 rounded-md rounded-r-none flex justify-center items-center md:ml-5 ml-3">
        <h1 className="md:text-base text-sm font-rom">Sort by</h1>
      </div>
      <div className="border-2 border-l-0 border-softGray md:h-10 h-8 md:w-44 w-32 rounded-md rounded-l-none flex justify-around items-center">
        <select
          onChange={handleSort}
          name="sorting"
          className="w-full h-full md:text-base text-sm font-rom my-3 px-2 shadow-sm transition duration-100 ease-in-out rounded-md rounded-l-none focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 cursor-pointer"
        >
          {defaultSort !== undefined && (
            <option value={defaultSort as any} selected hidden>
              {defaultSort}
            </option>
          )}
          {option.map((el: any, idx: number) => (
            <option value={el.value} key={idx}>
              {el.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default NewSorting;
